export const getSpettriMobileGameplayAdEnabled = ({
  completed,
  gameOver,
  isAnimatingReveal,
}) => !completed && !gameOver && !isAnimatingReveal;
